import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { UserModel } from './model';

export const userAdapter: EntityAdapter<UserModel> = createEntityAdapter<UserModel>({
  selectId: model => model.id,
});

export interface UserState extends EntityState<UserModel> {
  selected: UserModel | null;
  isLoading?: boolean;
  error?: any;
}

export const initialState: UserState = userAdapter.getInitialState({
  selected: null,
  isLoading: false,
  error: null,
});
